import adjustMenus from "../utils/adjustMenus";
import {throttle} from 'throttle-debounce';
import {animate, animateOnScroll} from "../utils/animate";

export default {
  init($, classRoutes) {

    $('.menu-trigger-button').on('click', () => $('body').toggleClass('menu-open'));

    const adjustElements = throttle(100, () => {
      adjustMenus();
    });

    $(window).on('resize', adjustElements).trigger('resize');

    $(window).on('scroll', throttle(10, () => {
      if (!$('body').hasClass('scroll') && $(window).scrollTop() > 50) {
        $('body').addClass('scroll');
      } else if ($('body').hasClass('scroll') && $(window).scrollTop() <= 50) {
        $('body').removeClass('scroll');
      }
    })).trigger('scroll');
  },

  finalize($) {

    setTimeout(function () {
      $(document).scrollTop(0);
      $('body').addClass('loaded');
      // animateOnScroll($('[data-animate]:not(.quotes-section [data-animate])'));

      require('venobox');
      $('.venobox').venobox({
        autoplay: true,
        bgcolor: '#fff',
        closeColor: '#195a8d',
        titleColor: '#195a8d'
      });

    }, 500);
    animateOnScroll($('[data-animate]'));
    // animate($('.quotes-section [data-animate]'));
    if (document.querySelector('.simple-banner-text') != null) {
      document.querySelector('#mainHeader').style.paddingTop = `${document.querySelector('.simple-banner-text').offsetHeight}px`;

      window.onscroll = () => {
        if (window.scrollY > 0) {
          document.querySelector('#mainHeader').removeAttribute('style');
        } else {
          document.querySelector('#mainHeader').style.paddingTop = `${document.querySelector('.simple-banner-text').offsetHeight}px`;
        }
      }
    }

    if (window.innerWidth <= 1200) {
      const linkList = document.querySelectorAll('#main-menu a');

      linkList.forEach(link => {
        const parent = link.closest('.menu-item');

        if (parent.querySelector('.sub-menu') != null) {
          parent.querySelector('a').appendChild(document.createElement('span'));
          parent.querySelector('a').setAttribute('style', 'justify-content: space-between; position: relative;')

          const span = parent.querySelector('span');
          span.setAttribute('style', 'display: block; width: 27px; height: 27px; position: absolute; top: 0; right: 0; z-index: 999;');

          span.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            document.querySelectorAll('#main-menu .sub-menu').forEach(sub => sub.style.display = 'none');
            parent.querySelector('.sub-menu').style.display = 'block';
            return false;
          });
        }
      });
    }

    // if (window.innerWidth <= 767) {
    //  const linkList = document.querySelectorAll('#main-menu a');

    //  linkList.forEach(link => {
    //   link.addEventListener('click', (e) => {
    //    const parent = e.target.closest('.menu-item');

    //    document.querySelectorAll('#main-menu .sub-menu').forEach(sub => sub.style.display = 'none');

    //    if (parent.querySelector('.sub-menu') != null) {
    //     e.preventDefault();
    //     parent.querySelector('.sub-menu').style.display = 'block';
    //    }
    //   });
    //  });
    // }

    const $anchNav = $('.anch-nav');
    if ($anchNav.length) {

      $anchNav.on('click', '.scrollTo', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: $($(this).attr('href')).offset().top-140}, 700);
      })

      /*if (location.hash && location.hash.length) {
        setTimeout(() => {
          let $title = $(location.hash);
          if ($title.length) {
            $('html, body').animate({scrollTop: $title.offset().top}, 1500, 'easeInSine');
          }
        }, 1800);
      }*/
    }

  },
};
